import { Button, SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ChartTitleLabel = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const StyledButton = styled(Button)`
  color: var(--text-primary);
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '36px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
